<template>
  <div class="row my-4 py-4">
  	<div class="col my-4 py-4">
		<div class="my-4 py-4 d-flex justify-content-center">
  			<h2 class="h1 d-flex align-items-center"><span class="pr-2 border-right">404</span><span class="h6 pl-2 mt-2">Not Found</span></h2>
		</div>
  	</div>    
  </div>
</template>

<script>
export default {};
</script>
<style>
</style>